import { FilterHandler, useFilterState } from '@btime/react-contexts'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import Form from '../../../packages/kiti/components/form/form/Form'
import Line from '../../../packages/kiti/components/helpers/Line'
import Modal from '../../../components/structure/Modal'
import ModalPickerFooter from '../../../components/form/modalPicker/ModalPickerFooter'
import ModalPickerHeader from '../../../components/form/modalPicker/ModalPickerHeader'
import Picker from '../../../packages/kiti/components/form/picker/Picker'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import SelectableListItem from '../../../packages/kiti/components/list/SelectableListItem'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import AssetsLoader, { useAssets } from '../_load/AssetsLoader'
import AssetFiltersList from '../filters/AssetFiltersList'
import SelectAllAssetsLink from '../SelectAllAssetsLink'

const Footer = ({ onClose, onChange, filter }) => {
  const { filter: filterState, search } = useFilterState()
  const { form, handleChangeIn } = useFormState()

  return (
    <ModalPickerFooter closeModal={onClose} onChange={onChange}>
      <SelectAllAssetsLink
        onSelect={handleChangeIn([])}
        value={form}
        useRawValues
        search={search}
        filter={{ ...filterState, ...filter }}
      />
    </ModalPickerFooter>
  )
}

const Content = ({ configName, ...props }) => {
  const { form, handleChangeIn } = useFormState()
  const options = useAssets()

  return (
    <Picker
      Selector={SelectableListItem}
      options={options}
      value={form || []}
      onChange={handleChangeIn([])}
      idField="id"
      labelField="name"
      descriptionField={['type', 'name']}
      {...props}
    />
  )
}

const AssetValuePickerModal = ({ open, onClose, value, onChange, level, ...props }) => {
  const { t } = useTranslation('assets')

  return (
    <Modal width="42rem" noPadding open={open} onClose={() => onClose()} level={level}>
      <FilterHandler>
        <Form initialState={value || []}>
          <ModalPickerHeader title={t('selectAssets')} filtersList={<AssetFiltersList />} {...props} />
          <Line />
          <Scroll height="65vh">
            <AssetsLoader>
              <Content closeModal={onClose} {...props} />
            </AssetsLoader>
            <Separator weight={12} />
          </Scroll>
          <Line />
          <Footer onClose={onClose} onChange={onChange} {...props} />
        </Form>
      </FilterHandler>
    </Modal>
  )
}

export default AssetValuePickerModal
